import './utils/logger';
import React from 'react';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux';
import {PigmentThemeProvider} from '@customink/pigment-react';
import {Provider as RollbarProvider} from '@rollbar/react';
import App from './containers/App';
import {store} from './store';
import rollbarConfig from './config/rollbar';

import './index.scss';

const mountNode = document.querySelector('#root');
ReactDOM.render(
  <RollbarProvider config={rollbarConfig}>
    <Provider store={store}>
      <PigmentThemeProvider>
        <App />
      </PigmentThemeProvider>
    </Provider>
  </RollbarProvider>,
  mountNode
);
